import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	eVoting: [],
};

// active account slice
export const allEServicesSlice = createSlice({
	name: 'eServices',
	initialState,
	reducers: {
		setAllEVoting: (state, action) => {
			state.eVoting = action.payload;
		},
	},
});

export const {
	setAllEVoting,
} = allEServicesSlice.actions;

export default allEServicesSlice.reducer;
